import { Check } from 'lucide-react'

/**
 * "Safety snapshot" phone mockup illustrating the compliance-monitoring
 * StepCard on the How We Use AI page. Static content, not a live device
 * frame — gauge arcs/needle rotation are fixed to match the design. Sits
 * as a StepCard-sized grid cell, dark-surface only (same as StepCard).
 */
export function SafetySnapshotCard() {
  return (
    <div className="flex items-stretch justify-center">
      <div className="w-full max-w-80 rounded-[42px] border border-white/20 bg-white/10 p-2.5">
        <div className="bg-surface flex flex-col overflow-hidden rounded-[34px]">
          <div className="flex items-center justify-between px-5.5 pt-3.5 pb-1.5">
            <span className="text-ink font-mono text-[11px] font-bold">9:41</span>
            <span className="flex items-center gap-1">
              <span className="border-ink-400 block h-2 w-4 rounded-sm border" />
              <span className="bg-ink-400 block h-2 w-1 rounded-xs" />
            </span>
          </div>
          <div className="flex flex-col gap-4.5 px-5 pt-2.5 pb-4.5">
            <div className="flex items-start justify-between gap-4">
              <span className="text-ink-500 font-mono text-xs tracking-[0.14em] uppercase">
                Safety snapshot
              </span>
              <div className="flex flex-col items-end gap-1.5">
                <span className="text-ink rounded-full bg-(--amber) px-3 py-1 font-mono text-xs font-bold tracking-[0.14em] whitespace-nowrap uppercase">
                  Worth attention
                </span>
                <span className="text-ink-500 font-mono text-xs whitespace-nowrap">Renewal in 94 days</span>
              </div>
            </div>
            <div className="flex items-center justify-center py-0.5">
              <svg viewBox="0 0 200 112" className="block h-[134px] w-60" aria-hidden="true">
                <path d="M14 100A86 86 0 0 1 54.4 27.1" fill="none" stroke="#E0383B" strokeWidth={13} />
                <path d="M59.6 24.1A86 86 0 0 1 140.4 24.1" fill="none" stroke="#F6B100" strokeWidth={13} />
                <path d="M145.6 27.1A86 86 0 0 1 186 100" fill="none" stroke="#31AB6A" strokeWidth={13} />
                <g transform="rotate(20 100 100)">
                  <line
                    x1={100}
                    y1={100}
                    x2={100}
                    y2={32}
                    stroke="var(--ink)"
                    strokeWidth={4}
                    strokeLinecap="round"
                  />
                </g>
                <circle cx={100} cy={100} r={7} fill="var(--ink)" />
              </svg>
            </div>
            <div className="border-ink-100 flex flex-col gap-3.5 border-t pt-4.5">
              <div className="flex items-center gap-3">
                <span className="block size-2 flex-none rounded-full bg-(--amber)" />
                <span className="text-ink text-md font-bold">Hours-of-service flags</span>
                <span className="flex-1" />
                <span className="font-mono text-sm font-bold text-(--amber)">2</span>
              </div>
              <div className="flex items-center gap-3">
                <span className="block size-2 flex-none rounded-full bg-(--amber)" />
                <span className="text-ink text-md font-bold">Expiring medical cards</span>
                <span className="flex-1" />
                <span className="font-mono text-sm font-bold text-(--amber)">1</span>
              </div>
              <div className="flex items-center gap-3">
                <Check className="text-brand-600 size-4 flex-none" strokeWidth={3} aria-hidden="true" />
                <span className="text-ink-500 text-md font-bold">Maintenance current</span>
                <span className="flex-1" />
                <span className="text-ink-500 font-mono text-sm font-bold">8 / 8</span>
              </div>
            </div>
          </div>
          <div className="flex justify-center pb-2">
            <span className="bg-ink-200 block h-1 w-24 rounded-full" />
          </div>
        </div>
      </div>
    </div>
  )
}
